import { Drawer, debounce } from "//nuxe.co.jp/cdn/shop/t/12/assets/theme.js?v=109729746023501300491764653040";
var FiltersSelection = class extends HTMLElement {
  constructor() {
    super();
    this.filters = this.dataset.filters.split(",");
    this.options = {};
    this.btn = this.querySelector(".btn");
    this.linkUrl = this.btn?.href;
    this.init();
  }

  init() {
    this.filters.map(filter => {
      const select = this.querySelector(`[role="${filter}"]`);
      select.addEventListener("change", e =>
        this.changeOptions(e.target.dataset.filter)
      );
      this.options[filter] = Array.from(select.options);
    });
    this.changeOptions(this.filters[0]);
  }

  positionIcons() {
    this.filters.map(filter => {
      const item = this.querySelector(`[role="${filter}"]`).parentElement;
      const icon = item.querySelector(".care-filters__form__item__icon");
      const select = item.querySelector(".care-filters__form__item__select");
      const text = select.options[select.selectedIndex].text;
      const measurer = document.createElement("span");
      measurer.innerHTML = text;
      measurer.style.display = "inline-block";
      measurer.classList.add("care-filters__form__item__select");
      item.append(measurer);
      const measurerWidth = measurer.clientWidth;
      measurer.remove();
      const selectPosition = { x: select.offsetLeft, y: select.offsetTop };
      icon.style.left = `${selectPosition.x + measurerWidth}px`;
      icon.style.top = `${selectPosition.y}px`;
    });
  }

  createLink() {
    if (!this.btn || !this.linkUrl) return;
    let linkUrl = `${this.linkUrl}?`;
    this.filters.map((filter, index) => {
      const item = this.querySelector(`[role="${filter}"]`).parentElement;
      const select = item.querySelector(".care-filters__form__item__select");
      const value = select.value.replaceAll(":", "%3A").replaceAll("/", "%2F");
      linkUrl += `${index > 0 ? "&" : ""}filter.p.m.custom.search_axis${
        index + 1
      }=${value}`;
    });
    this.btn.href = linkUrl;
  }

  changeOptions(filter) {
    const filterIndex = this.filters.indexOf(filter);
    for (let i = filterIndex + 1; i < this.filters.length; i++) {
      const value = this.querySelector(`[role="${this.filters[i - 1]}"]`).value;
      const select = this.querySelector(`[role="${this.filters[i]}"]`);
      const options = this.options[this.filters[i]];
      select.innerHTML = "";
      options.map(option => {
        const include = option.dataset.include;
        if (include.includes(value)) select.append(option);
      });
    }
    this.positionIcons();
    this.createLink();
  }
};
if (!window.customElements.get("filters-selection")) {
  window.customElements.define("filters-selection", FiltersSelection);
}

// dropdown mobile
var DropdownMobile = class extends HTMLButtonElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("click", event => {
      const parent = this.parentElement;
      parent.classList.toggle("open");
      if (this.dataset.fill) {
        this.fillSelectedDropdown(parent);
      }
    });
  }

  fillSelectedDropdown(parent) {
    parent.querySelectorAll(".js-dropdown-mobile-text").forEach(item =>
      item.addEventListener("click", event => {
        parent.querySelector(".js-dropdown-mobile-selected").innerText =
          event.target.innerText;
      })
    );
  }
};

if (!window.customElements.get("dropdown-mobile")) {
  window.customElements.define("dropdown-mobile", DropdownMobile, {
    extends: "button",
  });
}

// MAINMENU
var Mainmenu = class extends HTMLElement {
  constructor() {
    super();
    this.tabmenu = window.matchMedia("screen and (min-width: 1440px)").matches;
    this.burger = window.matchMedia("screen and (max-width: 1439px)").matches;
   
  }
  connectedCallback() {
    if (this.burger) {
      this.initBurgerMenu();
    }
    if (this.tabmenu) {
      this.initTabMenu();
    }
  }
  initBurgerMenu() {
    this.addEventListener("click", function (e) {
      const el = e.target;
      // open submenu
      if (el.classList.contains("js-open-submenu")) {
          e.preventDefault();
          el.closest('.menu_item').classList.add('menu_item_active');
      }
      // close submenus
      if (el.classList.contains("js-close-menu")) {
        if (el.closest(".menu_item_level_1.menu_item_active")) {
          e.stopImmediatePropagation();
          el.closest(".menu_item_level_1").classList.remove("menu_item_active");
        } else {
          el.closest(".menu_item_level_0").classList.remove("menu_item_active");
        }
      }
    });
  }
  initTabMenu() {
    this.addEventListener("mouseover", function (e) {
      const el = e.target;
      // level 0
      if (el.classList.contains("js-open-submenu")) {
        const rootSelectedMenu = el.closest('.menu_item');
        // active level 0
        this.querySelector('.menu_item_active.menu_item_level_0')?.classList.remove('menu_item_active');
        rootSelectedMenu.classList.add('menu_item_active');
        // active first tabmenu (level 1) of level 0
        rootSelectedMenu.querySelector('.menu_item_tab:first-child').classList.add('menu_submenu_tab_active');
        rootSelectedMenu.querySelector('.menu_submenu_tab_item:first-child').classList.add('menu_submenu_tab_active');
      } else if (el.classList.contains("menu_item_level_0_link")) {
        // unactive level 0 if no child submenu
        this.querySelector('.menu_item_active.menu_item_level_0')?.classList.remove('menu_item_active');
      }
      // level 1 => tabs
      if (el.classList.contains("js-open-tab")) {
        const parent = el.closest('.menu_item_tab');
        const index = findSelectorIndex(parent) + 1;
        // remove
        this.querySelectorAll('.menu_item_tab').forEach(tab => { tab.classList.remove('menu_submenu_tab_active')
        });
        this.querySelectorAll('.menu_submenu_tab_item').forEach(tab => { tab.classList.remove('menu_submenu_tab_active')
        });
        
        // add
        parent.classList.add('menu_submenu_tab_active');
        parent.closest('.menu_submenu_type_tab').querySelector('.menu_submenu_tab_item:nth-child('+ index +')')?.classList.add('menu_submenu_tab_active');
      }
    });
    this.addEventListener("mouseleave", function (e) {
      const el = e.target;
      // remove active level 0
      this.querySelector('.menu_item_active.menu_item_level_0')?.classList.remove('menu_item_active');
      // remove active level 1
      this.querySelector('.menu_item_tab.menu_submenu_tab_active').classList.remove('menu_submenu_tab_active');
      this.querySelector('.menu_submenu_tab_item.menu_submenu_tab_active').classList.remove('menu_submenu_tab_active');
    });
  }
};
if (!window.customElements.get("main-menu")) {
  window.customElements.define("main-menu", Mainmenu);
}

//
class ObfuscatedLink extends HTMLElement {
  constructor() {
    super();
    this.href = this.getAttribute("data-href");
    this.target = this.getAttribute("target");
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      if (this.href) {
        if (this.target == "_blank") {
          window.open(this.href, "_blank");
          return;
        }
        window.location.href = this.href;
      }
    });

    this.addEventListener("auxclick", e => {
      if (this.href) {
        window.open(this.href, "_blank");
      }
    });
  }

  disconnectedCallback() {
    this.removeEventListener("click");
    this.removeEventListener("auxclick");
  }
}
if (!window.customElements.get("obfuscated-link")) {
  window.customElements.define("obfuscated-link", ObfuscatedLink);
}

class EnableSubmit extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector(".checkbox");
    this.submitBtn = this.checkbox
      .closest("form")
      .querySelector("button[type=submit]");
  }
  connectedCallback() {
    this.checkbox.addEventListener("change", e => {
      if (e.target.checked) {
        this.submitBtn.disabled = false;
      } else {
        this.submitBtn.disabled = true;
      }
    });
  }
}
if (!window.customElements.get("enable-submit")) {
  window.customElements.define("enable-submit", EnableSubmit);
}

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("click", this.showContent);
    this.content = document.getElementById(this.dataset.targetId);
    this.checkButton();
  }

  checkButton() {
    const containerHeight = this.content.clientHeight;
    const contentHeight = this.content.scrollHeight;
    this.style.display =
      containerHeight < contentHeight ? "inline-block" : "none";
  }

  showContent() {
    if (!this.content) return;
    this.content.style.display = "block";
    this.style.display = "none";
  }
}
if (!window.customElements.get("show-more-button")) {
  window.customElements.define("show-more-button", ShowMoreButton);
}

class FAQContent extends HTMLElement {
  constructor() {
    super();
    this.subjects =
      this.querySelector(".faq__subjects").querySelectorAll(".faq__subject");
    this.faqsSections = this.querySelectorAll(".faq__section");
    this.questions = document.querySelectorAll(".faq__qa");
    this.search = this.querySelector(".faq__search");
    this.searchIsActive = false;
  }

  connectedCallback() {
    this.subjects.forEach(subject =>
      subject.addEventListener("click", () => this.displayFAQ(subject))
    );
    this.questions.forEach(q =>
      q.addEventListener("click", () => {
        q.classList.toggle("open");
      })
    );
    this.search.addEventListener("keyup", () => this.displaySearchResult());
  }

  disconnectedCallback() {
    this.subjects.forEach(subject => subject.removeEventListener("click"));
    this.question.forEach(subject => subject.removeEventListener("click"));
    this.search.removeEventListener("keyup");
  }

  displayFAQ(subject) {
    if (this.searchIsActive) {
      this.resetSearch();
    }

    this.subjects.forEach(subject => subject.classList.remove("active"));
    subject.classList.add("active");
    const subjectToDisplay = subject.getAttribute("subject");
    this.faqsSections.forEach(section => {
      if (section.classList.contains(subjectToDisplay)) {
        section.classList.remove("hidden");
      } else {
        section.classList.add("hidden");
      }
    });
  }

  displaySearchResult() {
    this.searchIsActive = true;
    const value = this.search.value;

    this.faqsSections.forEach(section => {
      section.classList.add("hidden");

      const QAs = section.querySelectorAll(".faq__qa");
      QAs.forEach(qa => {
        qa.classList.add("hidden");

        const question = qa.querySelector(".faq__qa--question");
        const content = question.dataset.question;
        const answer = qa.querySelector(".faq__qa--answer");
        const answerContent = answer.dataset.answer;

        if (content.includes(value)) {
          section.classList.remove("hidden");
          qa.classList.remove("hidden");

          const instances = new RegExp(value, "g");
          const hightlightedText = content.replace(
            instances,
            `<span class="highlight">${value}</span>`
          );
          question.innerHTML = hightlightedText;
        }
        if (answerContent.includes(value)) {
          section.classList.remove("hidden");
          qa.classList.remove("hidden");

          const instances = new RegExp(value, "g");
          const hightlightedText = answerContent.replace(
            instances,
            `<span class="highlight">${value}</span>`
          );
          answer.querySelector(".metafield-rich_text_field").innerHTML =
            hightlightedText;
          if (value != "") {
            qa.classList.add("open");
          } else {
            qa.classList.remove("open");
          }
        }
      });
    });
  }

  resetSearch() {
    this.search.value = "";
    this.questions.forEach(qa => {
      qa.classList.remove("hidden");

      const question = qa.querySelector(".faq__qa--question");
      question.innerHTML = question.dataset.question;
    });
    this.searchIsActive = false;
  }
}
if (!window.customElements.get("faq-content")) {
  window.customElements.define("faq-content", FAQContent);
}

// HIDE YOTPO REVIEWS IF EMPTY
let hideEmptyReviewsBlock = () => {
  checkElementInDom("#yotpo-reviews-main-widget").then(() => {
    const reviewsBlock = document.querySelector("#yotpo-reviews-main-widget");
    if (reviewsBlock.querySelector(".yotpo-empty-state") != undefined) {
      // console.log('empty reviews')
      reviewsBlock.closest(".section").style.display = "none";
    }
  });
};

//************* */ TOOLS : **********//
// check if selector exists in dom
function checkElementInDom(el) {
  if (document.querySelector(el) != null) {
    return new Promise((resolve, reject) => {
      resolve();
    });
  } else {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        checkElementInDom(el).then(resolve);
        // Recursively call and resolve the promise when the element is found
      }, 2000);
    });
  }
}
// find index of selector
function findSelectorIndex(child) {
  return Array.from(child.parentNode.children).indexOf(child);
}
//************* */ END TOOLS : **********//


// if page product page
if (document.querySelector(".shopify-section--main-product") != undefined) {
  hideEmptyReviewsBlock();
}

// OVERRIDE EVENT MENU QIKIFY
let eventMenuMobile = () => {
  let nav = document.querySelector("navigation-drawer");
  // bouton retour
  nav.addEventListener("click", function (e) {
    let el = e.target;
    if (el.className == "tmenu_item_link") {
      if (el.closest(".tmenu_item_level_1.tmenu_item_active")) {
        el.closest(".tmenu_item_level_1").classList.remove("tmenu_item_active");
      } else {
        el.closest(".tmenu_item_level_0").classList.remove("tmenu_item_active");
      }
    }
  });
};
eventMenuMobile();

// for product set routine

var QuickBuyMultipleDrawer = class extends Drawer {
  constructor() {
    super();
    this.addEventListener("dialog:after-hide", this._submitForm);
  }
  _submitForm() {
    // const form = this.querySelector("#facet-form");
    // if (HTMLFormElement.prototype.requestSubmit) {
    //   form.requestSubmit();
    // } else {
    //   form.dispatchEvent(new Event("submit", { cancelable: true }));
    // }
  }
  async show() {
    this.style.display = "block";
    return super.show();
  }
  onVariantAdded() {
    const tempContent = document.createElement("div");
    //tempContent.innerHTML = event.detail.cart["sections"]["variant-added"];
    //this.replaceChildren(...tempContent.querySelector(".shopify-section").children);
    this.show();
  }
};
if (!window.customElements.get("quick-buy-multiple-drawer")) {
  window.customElements.define(
    "quick-buy-multiple-drawer",
    QuickBuyMultipleDrawer
  );
}

// show password
var ShowPassword = class extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector(".js-icon");
    this.input = this.querySelector("input");
  }
  connectedCallback() {
    this.icon.addEventListener("click", this.showPass.bind(this));
  }
  showPass() {
    this.classList.toggle("show");
    const input = this.input;
    if (input.type == "password") {
      input.type = "text";
    } else {
      input.type = "password";
    }
  }
};
if (!window.customElements.get("show-password")) {
  window.customElements.define("show-password", ShowPassword);
}

// COLLAPSE TEXT (lire plus)
var CollapseText = class extends HTMLElement {
  constructor() {
    super();
    const prose = this.getAttribute("prose");
    const lineClampInit = () => {
      if (prose) {
        const proseContent = this.querySelector(".prose");
        this.maxLines = this.getAttribute("max-lines");
        this.clampClass = "line-clamp-prose-" + this.maxLines;
        const elemHeight = proseContent.offsetHeight;
        const lineHeight = window
          .getComputedStyle(proseContent)
          .lineHeight.replace("px", "");
        const lines = elemHeight / lineHeight;
        // console.log('elemHeight',proseContent.offsetHeight);
        // console.log('lineHeight',lineHeight);
        // console.log('lines',lines);
        // console.log('max-lines',this.maxLines);
        // console.log('clampClass',this.clampClass);

        if (isNaN(lines) || lines <= this.maxLines) {
          this.classList.remove(this.clampClass);
          this.classList.add("active");
        } else {
          this.classList.add(this.clampClass);
          this.classList.remove("active");
        }
      }
    };
    this.addEventListener("click", e => {
      let el = e.target;
      if (el.className == "collapse__action") {
        this.classList.add("active");
        if (prose) {
          this.classList.remove(this.clampClass);
        }
      }
    });
    lineClampInit();
  }
};
if (!window.customElements.get("collapse-text")) {
  window.customElements.define("collapse-text", CollapseText);
}

// CLICK AREA
var ClickArea = class extends HTMLElement {
  constructor() {
    super();
    this.disabled = this.getAttribute("disable-click");
    this.targetSelector = this.querySelector(this.getAttribute("target"));
  }
  connectedCallback() {
    this.addEventListener("click", e => {
      if (!this.disabled) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.targetSelector.click();
      }
    });
  }
};
if (!window.customElements.get("click-area")) {
  window.customElements.define("click-area", ClickArea);
}
